import { TranslateObjectFunction, useI18N } from '@tm/client-form/src/hooks/useI18n'
import { Field } from '@tm/shared-lib/src/field'
import { useCallback, useMemo } from 'react'
import { ViewProps } from '../types'
import { ReviewFields } from './useReviewFields'

const getTranslatedValues = (field: Field | undefined, tt: TranslateObjectFunction) => {
  const values = {
    label: '',
    description: '',
    inputLabel: '',
  }

  if (!field || field.type !== 'comment') return values

  const { label, description, inputLabel } = field

  values.label = tt(label)
  values.description = tt(description)
  values.inputLabel = tt(inputLabel)

  return values
}

export function useTextReview(props: ViewProps, reviewFields: ReviewFields) {
  const { state, dispatch, validationErrors } = props
  const { t, tt } = useI18N()

  const commentField = reviewFields.get('comment')

  const commentValue = state.values.comment || ''

  const onCommentChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'set value',
        field: {
          name: 'comment',
          system: true,
        },
        value,
      })
    },
    [dispatch]
  )

  const { label, description, inputLabel } = getTranslatedValues(commentField, tt)

  const commentError = useMemo(() => {
    if (validationErrors.comment) {
      return validationErrors.comment.map(error => t(error)).join(', ')
    }
    return ''
  }, [validationErrors, t])

  return {
    hasTextReview: !!commentField,
    commentValue,
    onCommentChange,
    commentError,
    label,
    description,
    inputLabel,
  }
}

export type UseTextReview = ReturnType<typeof useTextReview>
